import React from 'react';

const CheckboxField = ({ name, handleChange, label }) => {

	const handleCheckboxToggle = (e) => {
		const target = {
			name,
			value: e.target.checked
		}
		handleChange({ target });
	};

	return (
		<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingTop: '2px', paddingBottom: '1px' }}>
			<input
				type='checkbox'
				name={name}
				onChange={handleCheckboxToggle}
			/>
			<label htmlFor={label}>{label}</label>
		</div>
	);
}

export default CheckboxField;
